// ClientLocalizationProvider.tsx
'use client';

import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface ClientLocalizationProviderProps {
  children: React.ReactNode;
}

export default function ClientLocalizationProvider({
  children,
}: ClientLocalizationProviderProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {children}
    </LocalizationProvider>
  );
}
